import styled from "styled-components";
import OrderCalendar from "./mocks/orderCalendar/OrderCalendar";
import FormInput from "./mocks/form/FormInput";
import Card from "./mocks/card/Card";
import ProductAddonGroups from "./mocks/product/ProductAddonGroups";

const Container = styled.div`
  > h3 {
    margin-bottom: 10px;
    margin-top: 10px;
    color: black;
  }
`;

const ComponentCard = styled(Card)`
  margin-top: 10px;
`;

type WebComponentPreviewProps = {
  className?: string;
};

export default function WebComponentPreview({
  className,
}: WebComponentPreviewProps) {
  return (
    <Container className={className}>
      <h3>Order calendar</h3>
      <OrderCalendar />

      <ComponentCard>
        <FormInput label="Input Value" fieldName="" required />
      </ComponentCard>

      <ComponentCard>
        <ProductAddonGroups />
      </ComponentCard>
    </Container>
  );
}
